import { DateInput as MantineDateInput, DateInputProps } from '@mantine/dates';

export type IDateInputProps = DateInputProps;

/** @registry Design-layer pass-through over Mantine DateInput; import this instead of @mantine/dates DateInput outside src/design. Extend here when DateInput needs house behavior. */
export const DateInput = MantineDateInput;
